import { warehouseStrings } from '@data/warehouse';
import { requiredStringField } from '@utils/forms';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const warehouseBaseWithoutAgency = t.type({
  city: t.string,
  name: t.string,
  name_en: t.string,
  zipcode: t.string,
  address1: t.string,
  address2: t.string,
  principal_name: t.string,
  phone: t.string,
  memo: t.string,
});

export type WarehouseBaseWithoutAgency = t.TypeOf<typeof warehouseBaseWithoutAgency>;

export const warehouseBase = t.type({
  ...warehouseBaseWithoutAgency.props,
  agency_id: t.number,
});

export type WarehouseBase = t.TypeOf<typeof warehouseBase>;

export const warehouse = t.type({
  ...warehouseBase.props,
  id: t.number,
  updated_at: t.string,
  created_at: t.string,
});

export type Warehouse = t.TypeOf<typeof warehouse>;

export const warehouseQuery = t.partial({
  agency_id: t.number,
});

export type WarehouseQuery = t.TypeOf<typeof warehouseQuery>;

export const warehouseForm = t.type({
  city: requiredStringField(warehouseStrings.city),
  name: requiredStringField(warehouseStrings.name),
  name_en: requiredStringField(warehouseStrings.englishName),
  zipcode: requiredStringField(warehouseStrings.zipcode),
  address1: requiredStringField(warehouseStrings.address1),
  address2: requiredStringField(warehouseStrings.address2),
  principal_name: requiredStringField(warehouseStrings.principalName),
  phone: requiredStringField(warehouseStrings.phone),
  memo: requiredStringField(warehouseStrings.memo),
  agency_id: h.number().cast(),
});

export type WarehouseForm = t.TypeOf<typeof warehouseForm>;

export const warehouseInitialValues: Omit<WarehouseForm, 'agency_id'> = {
  city: '',
  name: '',
  name_en: '',
  zipcode: '',
  address1: '',
  address2: '',
  principal_name: '',
  phone: '',
  memo: '',
};
